"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assert = assert;
exports.currentISOTime = currentISOTime;
exports.currentTimestamp = currentTimestamp;
exports.generateUUID = generateUUID;
exports.removeTrailingSlash = removeTrailingSlash;
exports.retriable = retriable;
exports.safeSetTimeout = safeSetTimeout;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function assert(truthyValue, message) {
  if (!truthyValue) {
    throw new Error(message);
  }
}
function removeTrailingSlash(url) {
  return url === null || url === void 0 ? void 0 : url.replace(/\/+$/, '');
}
function retriable(_x) {
  return _retriable.apply(this, arguments);
}
function _retriable() {
  _retriable = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(fn) {
    var props,
      _props$retryCount,
      retryCount,
      _props$retryDelay,
      retryDelay,
      _props$retryCheck,
      retryCheck,
      lastError,
      i,
      res,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            props = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _props$retryCount = props.retryCount, retryCount = _props$retryCount === void 0 ? 3 : _props$retryCount, _props$retryDelay = props.retryDelay, retryDelay = _props$retryDelay === void 0 ? 5000 : _props$retryDelay, _props$retryCheck = props.retryCheck, retryCheck = _props$retryCheck === void 0 ? function () {
              return true;
            } : _props$retryCheck;
            lastError = null;
            i = 0;
          case 4:
            if (!(i < retryCount + 1)) {
              _context.next = 23;
              break;
            }
            if (!(i > 0)) {
              _context.next = 8;
              break;
            }
            _context.next = 8;
            return new Promise(function (r) {
              return setTimeout(r, retryDelay);
            });
          case 8:
            _context.prev = 8;
            _context.next = 11;
            return fn();
          case 11:
            res = _context.sent;
            return _context.abrupt("return", res);
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](8);
            lastError = _context.t0;
            if (retryCheck(_context.t0)) {
              _context.next = 20;
              break;
            }
            throw _context.t0;
          case 20:
            i++;
            _context.next = 4;
            break;
          case 23:
            throw lastError;
          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 15]]);
  }));
  return _retriable.apply(this, arguments);
}
function generateUUID(globalThis) {
  var d = new Date().getTime();
  var d2 = globalThis && globalThis.performance && globalThis.performance.now && globalThis.performance.now() * 1000 || 0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
}
function currentTimestamp() {
  return new Date().getTime();
}
function currentISOTime() {
  return new Date().toISOString();
}
function safeSetTimeout(fn, timeout) {
  var t = setTimeout(fn, timeout);
  (t === null || t === void 0 ? void 0 : t.unref) && (t === null || t === void 0 ? void 0 : t.unref());
  return t;
}